import { render, staticRenderFns } from "./Departure.vue?vue&type=template&id=8917d854&"
import script from "./Departure.vue?vue&type=script&lang=js&"
export * from "./Departure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports